import { IInventoryPage } from '../../../inventory-page.interface';


export const RESEARCH_TRADEMARK_TM_WATCHLIST_PAGE: IInventoryPage = {
	'route': '/research/trademark/tm-watchlist',
	'title': 'TM Watchlist',
	'uiReference': [
		'Watchlist tools',
		'Enter a trademark to monitor',
		'Search saved entries',
		'Watchlist entry',
		'Monitor a trademark',
		'Add a word or phrase and choose the jurisdiction you want to monitor.',
		'Notifications',
		'Import',
		'Export',
		'Word or phrase',
		'Country',
		'Add to watchlist',
		'Saved monitoring',
		'watchlist entries',
		'Delete all',
		'Filter results',
		'Refine results',
		'Filter your watchlist',
		'Filter the entries already loaded on this page.',
		'Reset filters',
		'Find an entry by its monitored text.',
		'Filter by word or phrase',
		'Countries',
		'Choose one or more monitored jurisdictions.',
		'Status',
		'Show filed or registered trademark matches.',
		'No watchlist entries found',
		'Adjust the active filters to see more results.',
		'Rows per page',
		'Legal notice: This is not legal advice. Each user remains responsible for verifying trademark information and determining whether a mark is safe to use.',
		'The spreadsheet import supports the following formats: .csv, .xls, .xlsx, .odt. The format of the spreadsheet must match the example below. Columns can be rearranged and are detected by their names.',
		'What is the Watchlist ?',
		'results',
		'Registered',
		'Filed',
		'Enter a page number',
		'Go to page',
		'Page number',
		'Loading...',
		'Sorry, there was an internal error. Please contact support.'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/trademark-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/tm-watchlist/tm-watchlist.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/tm-watchlist/tm-watchlist.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/tm-watchlist/tm-watchlist.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-status-column/tm-status-column.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-status-column/tm-status-column.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-search-column/tm-search-column.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-search-column/tm-search-column.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-pagination/tm-pagination.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/research/trademark/shared-components/tm-pagination/tm-pagination.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/api-loading-card/api-loading-card.component.html'
	],
	'aliases': []
};
